import { Box } from 'braid-design-system';
import type { FC } from 'react';

import * as styles from './styles.css';

interface TextSkeletonProps {
  height?: keyof typeof styles.height;
  width?: string;
}

export const TextSkeleton: FC<TextSkeletonProps> = ({
  height = 'small',
  width = '70%',
}) => (
  <Box
    display="flex"
    component="span"
    background="neutralLight"
    borderRadius="standard"
    className={styles.height[height]}
    style={{
      width,
    }}
  />
);
